import { Parallax } from "react-parallax";
import { ProperCare, ToBuy } from "../../../../AnchorContext";
import { ColorSection } from "../../../../ColorContext";
import style from "./ToBuy.module.scss";

export const ToBuySection = () => {
  return (
    <ToBuy.Section>
      <ColorSection background="white" className={style.toBuy}>
        <div className={`${style.toBuy__wrapper} wrapper`}>
          <div className={style.toBuy__leftSide}>
            <div className={style.leftSide__title}>
              Иммунитет <br /> для вашего авто
            </div>
            <div className={style.leftSide__desc}>
              Приобрести иммунитет вашему автомобилю поможет
              Hi-Gear&nbsp;&mdash; ведущий мировой производитель качественной
              автохимии и&nbsp;автокосметики. Универсальная линейка
              и&nbsp;высочайшее качество средств по&nbsp;уходу, строгий научный
              подход в&nbsp;адаптации составов к&nbsp;местным особенностям
              климата и&nbsp;эксплуатации, а&nbsp;также специальная система
              контроля качества сохранят здоровье вашей машины на&nbsp;долгие
              годы. Вы&nbsp;за иммунитетом? Вам <ProperCare.Link>сюда</ProperCare.Link>
            </div>
          </div>
          <div className={style.toBuy__rightSide}>
            <div className={style.rightSide__img}>
              <Parallax bgImage={"/images/toBuyDude.png"} strength={-50}>
                <div style={{ height: "100%", width: "100%" }}></div>
              </Parallax>
            </div>
          </div>
        </div>
      </ColorSection>
    </ToBuy.Section>
  );
};